import React from 'react';
import { REPORT_PRESETS, MAX_REPORT_DAYS } from '../../../../constants/journey';
import { daysBetween, todayISO } from '../../../../utils/journeyDates';
import styles from './ReportRangePicker.module.css';

// Presets are rolling windows ending today — "the last 7 days", not "this
// week". A custom range is computed like any other, but carries no AI text.
const ReportRangePicker = ({
	period,
	start,
	end,
	onPeriodChange,
	onStartChange,
	onEndChange,
}) => {
	const today = todayISO();
	const rangeTooLong =
		period === 'custom' &&
		start &&
		end &&
		daysBetween(start, end) > MAX_REPORT_DAYS;
	const rangeInverted = period === 'custom' && start && end && start > end;

	return (
		<div className={styles.picker}>
			<div className={styles.presets}>
				{REPORT_PRESETS.map((preset) => (
					<button
						key={preset.key}
						type='button'
						className={`${styles.preset} ${
							period === preset.key ? styles.presetActive : ''
						}`}
						onClick={() => onPeriodChange(preset.key)}
					>
						{preset.label}
					</button>
				))}
			</div>

			{period === 'custom' && (
				<div className={styles.custom}>
					<label className={styles.field}>
						<span className={styles.fieldLabel}>From</span>
						<input
							type='date'
							className={styles.input}
							value={start || ''}
							max={end || today}
							onChange={(event) => onStartChange(event.target.value)}
						/>
					</label>
					<label className={styles.field}>
						<span className={styles.fieldLabel}>To</span>
						<input
							type='date'
							className={styles.input}
							value={end || ''}
							min={start || undefined}
							max={today}
							onChange={(event) => onEndChange(event.target.value)}
						/>
					</label>
				</div>
			)}

			{period === 'custom' && (rangeTooLong || rangeInverted) && (
				<p className={styles.warning}>
					{rangeInverted
						? 'The start date has to come before the end date.'
						: `A report covers at most ${MAX_REPORT_DAYS} days. Pick a shorter range.`}
				</p>
			)}
		</div>
	);
};

export default ReportRangePicker;
